import { isEmpty } from "./tool";
export const validate = function (value, rules) {
  let flag = true;
  let tip = null;
  if (rules && rules.length > 0) {
    rules.every((rule) => {
      let msg = rule.message;
      for (let key in rule) {
        if (key == "message" || key == "title") return true;
        let rv = rule[key];
        switch (key) {
          case "required":
            if (rv && isEmpty(value)) {
              flag = false;
              tip = msg;
              return false;
            } else {
              return true;
            }
          case "min":
            if (value && value.length < rv) {
              flag = false;
              tip = msg;
              return false;
            } else {
              return true;
            }
          case "max":
            if (value && value.length > rv) {
              flag = false;
              tip = msg;
              return false;
            } else {
              return true;
            }
          case "regex":
            if (value && !new RegExp(rv).test(value)) {
              flag = false;
              tip = msg;
              return false;
            } else {
              return true;
            }
        }
      }
    });
  }
  return { flag, tip };
};
export const validateForm = function (form, rules) {
  const keys = Object.keys(rules);
  let state = true,
    error = null;
  for (let i = 0, l = keys.length; i < l; i++) {
    const key = keys[i];
    const { flag, tip } = validate(form[key], rules[key]);
    if (!flag) {
      state = false;
      error = tip;
      break;
    }
  }
  return { state, error };
};
